/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id   : 'cat',
        title: 'Catalogos',
        type : 'collapsable',
        icon : 'heroicons_outline:clipboard-document-list', // Icono de lista/catálogo
        children: [
            {
                id   : 'cat-3',
                title: 'Administradores',
                type : 'basic',
                icon : 'heroicons_outline:user-circle', // Icono de usuario admin
                link : '/catalogos/administradores',
            },
            {
                id   : 'cat-1',
                title: 'Técnicos',
                type : 'basic',
                icon : 'heroicons_outline:users', // Icono de grupos de usuarios
                link : '/catalogos/usuarios',
            },
            {
                id   : 'cat-2',
                title: 'Poductos',
                type : 'basic',
                icon : 'heroicons_outline:shopping-bag', // Icono de productos/compras
                link : '/catalogos/productos',
            },
            // {
            //     id   : 'cat-4',
            //     title: 'test chat',
            //     type : 'basic',
            //     icon : 'heroicons_outline:shopping-bag', // Icono de productos/compras
            //     link : '/catalogos/test',
            // }
        ]
    },
    {
        id   : 'tickets',
        title: 'Tickets',
        type : 'basic',
        icon : 'heroicons_outline:ticket', // Icono específico de ticket
        link : '/tickets',
    }
];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
